import GenericModel from '../generic-model';
import { SubProject } from '../project/sub-project';

export abstract class Task extends GenericModel {
  archived?: boolean;
  type?: string;
  sequenceNumber?: number;
  subProject?: SubProject;

  // only for display in daily planning view
  titleDisplay?: string;
  timeBudgetDisplay?: string;

  // for submit status display
  submitQueued?: boolean;
  submitInProgress?: boolean;
}

export enum TASK_TYPES {
  SUB_PROJECT_TASK = 'SubProjectTask',
  OTHER_TASK = 'OtherTask',
  LOAD_TASK = 'LoadTask'
}
